import type { IconProps } from '../types/IconProps.ts';
export const Globe: IconProps = {
    name: 'Globe',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<path d="M2 12h20M12 2c.75 0 1.75.71 2.63 2.64A18 18 0 0 1 16 12c0 2.93-.54 5.53-1.37 7.36C13.75 21.3 12.75 22 12 22s-1.75-.71-2.62-2.64A18 18 0 0 1 8 12c0-2.93.54-5.53 1.38-7.36C10.25 2.7 11.25 2 12 2" />`,
    ]
};